import { render, staticRenderFns } from "./195.vue?vue&type=template&id=1dda5ecc&scoped=true&"
var script = {}
import style0 from "./195.vue?vue&type=style&index=0&id=1dda5ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda5ecc",
  null
  
)

export default component.exports